import * as Yup from 'yup';

export const validationSchema = (isEmailChanged) =>
  Yup.object().shape({
    name: Yup.string()
      .required('First name is required')
      .max(50, 'Maximum length is 50 characters')
      .test(
        'Apostrophe is not allowed in name',
        'Apostrophe is not allowed in name',
        (value) => {
          const _v = value || '';
          return !_v.match(/^.*'.*$/);
        },
      )
      .nullable(),
    surname: Yup.string()
      .required('Last name is required')
      .max(50, 'Maximum length is 50 characters')
      .test(
        'Apostrophe is not allowed in name',
        'Apostrophe is not allowed in name',
        (value) => {
          const _v = value || '';
          return !_v.match(/^.*'.*$/);
        },
      )
      .nullable(),
    title: Yup.string().max(50, 'Maximum length is 50 characters'),
    escalationLevel: Yup.number().required('Escalation level is required'),
    userName: isEmailChanged
      ? Yup.string()
          .required('Username is required')
          .email('Username must be an email')
      : Yup.string().required('Username is required'),
    initials: Yup.string().required('Initials is required'),
    departmentId: Yup.string().required('Department is required'),
    roleNames: Yup.string().required('Role is required'),
    groupIdArray: Yup.array().required('Membership group is required'),
  });
